$(function () {
    $(".js-modalWindow").click(function() {
        $("body").append("<div class=overlay2></div>");
        $(".overlay2").fadeIn(300);
        var target = $(this).attr("href");
        var largeImage = "<img class='modalContent' src='" + target + "'>";
        $(".overlay2").append(largeImage);
        $("body").addClass("is-active");
        return false;
    });
    $("body").on("click",".overlay2",function() {
        $(this).fadeOut(300,function() {
            $(this).remove();
            //body要素に追加したclass属性を削除
            $("body").removeClass("is-active");
        });
    });
});